import React from 'react';
import { DragLayerMonitorProps } from '@minoru/react-dnd-treeview';
import styles from './DragPreview.module.css';
import { SidebarNodeType } from './SidebarNode';

type Props = {
    monitorProps: DragLayerMonitorProps<SidebarNodeType>;
};

export const DragPreview: React.FC<Props> = (props) => {
    const item = props.monitorProps.item;

    return (
        <div className={styles.root}>
            <div className={styles.label}>{item.text}</div>
        </div>
    );
};
